import React from 'react';
import autobind from 'core-decorators/lib/autobind';

import PropTypes from 'prop-types';

import videoSources from '@wix/wix-vod-shared/src/common/constants/video-sources';

import Vimeo from './external/vimeo';
import Youtube from './external/youtube';
import Facebook from './external/facebook';

const fullScreenChangeEventsList = ['fullscreenchange', 'mozfullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange'];

const playersMap = {
  [videoSources.YOUTUBE]: Youtube,
  [videoSources.VIMEO]: Vimeo,
  [videoSources.FACEBOOK]: Facebook,
};


export default class ExternalPlayer extends React.Component {

  static propTypes = {
    isVideoPlayRequested: PropTypes.bool,
    isVideoPauseRequested: PropTypes.bool,
    isVideoPlaying: PropTypes.bool,
    isVideoPaused: PropTypes.bool,

    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    onEnded: PropTypes.func,
    onIframeRef: PropTypes.func,

    onFullScreenChanged: PropTypes.func,

    videoItem: PropTypes.object.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
  };

  static defaultProps = {
    onPlay: _.noop,
    onPause: _.noop,
    onEnded: _.noop,

    onError: _.noop,
    onFullScreenChanged: _.noop,
    onIframeRef: _.noop,
  };


  componentWillMount() {
    this.addFullscreenEventHandler();
  }

  componentWillUnmount() {
    this.removeFullscreenEventHandler();
  }

  @autobind
  handleFullscreenChange() {
    this.props.onFullScreenChanged(this.isInFullScreen);
  }

  get isInFullScreen() {
    return Boolean(
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    );
  }

  addFullscreenEventHandler() {
    _.forEach(fullScreenChangeEventsList, eventName => (
      document.addEventListener(eventName, this.handleFullscreenChange)
    ));
  }

  removeFullscreenEventHandler() {
    _.forEach(fullScreenChangeEventsList, eventName => (
      document.removeEventListener(eventName, this.handleFullscreenChange)
    ));
  }

  render() {
    const {
      videoItem,
      isVideoPlayRequested,
      isVideoPauseRequested,
      isVideoPlaying,
      isVideoPaused,
      onPlay,
      onPause,
      onEnded,
      onIframeRef,
    } = this.props;

    if (!videoItem) {
      return null;
    }

    const { id, externalId, mediaExternUrl, videoSource } = videoItem;

    const ExternalPlayer = playersMap[videoSource];

    if (!ExternalPlayer) {
      return null;
    }

    return (
      <ExternalPlayer {...this.props}
                      key={id || externalId}
                      showControls
                      isVideoPlayRequested={isVideoPlayRequested}
                      isVideoPauseRequested={isVideoPauseRequested}
                      isVideoPlaying={isVideoPlaying}
                      isVideoPaused={isVideoPaused}
                      src={mediaExternUrl}
                      onPlay={onPlay}
                      onPause={onPause}
                      onEnd={onEnded}
                      onIframeRef={onIframeRef} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/player-external.js